import { jsxs, jsx } from "react/jsx-runtime";
import { ColorWhite } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { TopTitle, SecondaryTitle } from "./styles.js";
function HeaderTile({
  content,
  colorConfig
}) {
  var _a, _b, _c;
  return /* @__PURE__ */ jsxs(
    CostcoBox,
    {
      sx: {
        "& > p": {
          margin: 0
        },
        border: `3px solid ${ColorWhite}`,
        borderRadius: "6px",
        display: "inline-block",
        margin: "5px",
        maxWidth: "100%",
        minWidth: "40%",
        padding: "8px"
      },
      children: [
        /* @__PURE__ */ jsx(
          TopTitle,
          {
            color: (_b = (_a = colorConfig == null ? void 0 : colorConfig.primary_font_and_background_color) == null ? void 0 : _a.text_color) == null ? void 0 : _b.hex,
            children: content.tile_block.normal_text_field
          }
        ),
        /* @__PURE__ */ jsx(SecondaryTitle, { color: (_c = colorConfig == null ? void 0 : colorConfig.secondary_font_color) == null ? void 0 : _c.hex, children: content.tile_block.bold_text_field })
      ]
    }
  );
}
export {
  HeaderTile
};
